// import css
import React from 'react';
import './CompFooterBar.css'

function FooterBar() {
  return (
    <div>
      {/* Your app content */}
      <nav className="navbar nav-footer bg-light justify-content-center">
        <span className="navbar-brand text-white" >copy rights reserved by Hpatel</span>
      </nav>
    </div>
  );
}

export default FooterBar;
